







































import Vue from "vue";
import { BookingTemplateItem } from "../models/BookingTemplate";
import BookingTemplateItemDimension from "./BookingTemplateItemDimension.vue";
import { t } from "@/plugins/i18n";

// Egy sablon tételeinek egyetlen táblája (TransactionItems minta), soronként lenyitható dimenziókkal.
// A tételeket készen kapja (GetBookingTemplate) — nincs saját lekérés.
interface Methods {
  hasDimensions(item: BookingTemplateItem): boolean;
  toggleDim(item: BookingTemplateItem): void;
}

interface Data {
  columns: any[];
}

interface Props {
  items: BookingTemplateItem[];
}

export default Vue.extend<Data, Methods, {}, Props>({
  name: "BookingTemplateItems",

  components: {
    BookingTemplateItemDimension,
  },

  props: {
    items: { type: Array as () => BookingTemplateItem[], default: () => [] },
  },

  data(): Data {
    return {
      columns: [
        { cell: "barsCell", title: "", width: "70px", filterable: false, sortable: false },
        { cell: "sideCell", title: t("GeneralLedger_Oldal"), width: "130px" },
        { field: "accnoCode", title: t("FokonyviSzam"), width: "140px" },
        { field: "accnoName", title: t("Megnevezes") },
        { cell: "totalCell", title: t("GeneralLedger_Szorzo"), width: "90px" },
        // K2D dimcode1-3 (1–3. dimenzió) oszlopként; a 4–9. felosztások a lenyíló tab-nézetben.
        { field: "dimcode1Display", title: t("GeneralLedger_DimI"), width: "100px" },
        { field: "dimcode2Display", title: t("GeneralLedger_DimII"), width: "100px" },
        { field: "dimcode3Display", title: t("GeneralLedger_DimIII"), width: "100px" },
        { field: "bookTypeDisplay", title: t("Naplo"), width: "140px" },
        { field: "currency", title: t("Penznem"), width: "90px" },
        // { field: "invNo", title: "Csop.", width: "80px" },
        { field: "note", title: t("Megjegyzes") },
        { filterable: false, width: 0, }
      ],
    };
  },

  methods: {
    // A lenyíló tab-nézet a 4–9. dimenzió-felosztásokat mutatja; a sávok csak akkor él, ha van ilyen.
    // (Az 1–3. dimenzió külön oszlopként látszik.)
    hasDimensions(item: BookingTemplateItem): boolean {
      return !!(item.dimensions && item.dimensions.length > 0);
    },

    toggleDim(item: BookingTemplateItem) {
      item.showDimensions = !item.showDimensions;
    },
  },
});
